
import { defineComponent } from "vue";
import ContactFormInput, {
  CONTACT_FORM_FORM_DATA_DEFAULT,
} from "@/views/contact-form/ContactFormInput.vue";
import ContactFormCheck from "@/views/contact-form/ContactFormCheck.vue";
import ContactService from "@/api/contact.service";
import { AxiosError } from "axios";
import Utility from "@/assets/common/scripts/utility";

export interface ContactFormData {
  formData: ContactFormInputData;
  formStep: number;
  errorMessage: string;
}

export interface ContactFormInputData {
  inquiry_name: string;
  inquiry_company_name: string;
  inquiry_email: string;
  inquiry_tel: string;
  inquiry_order_no: string;
  inquiry_type: string;
  inquiry_content: string;
  inquiry_token: string;
}

export default defineComponent({
  name: "ContactForm",
  components: {
    ContactFormInput,
    ContactFormCheck,
  },
  data(): ContactFormData {
    return {
      formData: { ...CONTACT_FORM_FORM_DATA_DEFAULT },
      formStep: 1,
      errorMessage: "",
    };
  },
  methods: {
    onForwardToCheck(inputData: ContactFormInputData): void {
      this.formData = inputData;
      this.formStep = 2;
      Utility.onScrollTop();
    },
    onBackToInput(): void {
      this.formStep = 1;
      this.errorMessage = "";
      Utility.onScrollTop();
    },
    onCheckout(param: ContactFormInputData): void {
      ContactService.sendContactForm(param)
        .then(({ data }) => {
          if (data.result !== "0000" && data.errormsg) {
            throw new AxiosError(data.errormsg);
          }
          this.$router.push({
            name: "MessageSent",
          });
        })
        .catch((error: AxiosError) => {
          this.errorMessage = error.message;
        });
    },
  },
});
